export const setMachineID = (payload) => {
    return{
        type:"SET_MACHINE_ID",
        data:payload
    }
}

export const setActiveRole = (payload) => {
    return{
        type:"SET_ACTIVE_ROLE",
        data:payload
    }
}